{
  "newFeature": "合理化されたアプリケーションスイッチャーには、1　つのリストで有効になっているアプリのみが含まれるようになりました。",
  "newLayout": "新規レイアウト",
  "ok": "OK"
}
